import { render, staticRenderFns } from "./MassCopyConfirm.vue?vue&type=template&id=0afc8195"
import script from "./MassCopyConfirm.vue?vue&type=script&lang=js"
export * from "./MassCopyConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src188434148/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afc8195')) {
      api.createRecord('0afc8195', component.options)
    } else {
      api.reload('0afc8195', component.options)
    }
    module.hot.accept("./MassCopyConfirm.vue?vue&type=template&id=0afc8195", function () {
      api.rerender('0afc8195', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/MassCopyConfirm.vue"
export default component.exports